import React, { lazy, Suspense, useEffect, useMemo } from 'react';
import { SplashScreen } from '@berriesflow/core';
import { useAtomValue } from 'jotai';

import { _authState } from '../store/auth/_authState';
import useAuth from '../store/auth/useAuth';

const RouterNoLogin = lazy(() => import('./routerNolLogin'));
const ProducerRouter = lazy(() => import('./producerRouter'));

export default function App() {
  const { loadProfile } = useAuth();
  const { init, isLogged } = useAtomValue(_authState);

  const myRouter = useMemo(() => {
    if (isLogged) return <ProducerRouter />;
    return <RouterNoLogin />;
  }, [isLogged]);

  useEffect(() => {
    loadProfile();
  }, [loadProfile]);

  return (
    <>
      {init ? (
        <Suspense fallback={<SplashScreen />}>{myRouter}</Suspense>
      ) : (
        <SplashScreen />
      )}
    </>
  );
}
